
import React, { Component } from 'react'
import UnitRequestList from './UnitRequestList'


export default class UnitRequests extends Component {
    constructor() {
        super()
      
    }
   
    render() {
        return (
            <div className="row">
                <article className="col-xs-12">
                    <div className="jarviswidget" id="wid-id-0" data-widget-editbutton="false">
                        <header>
                            <span class="widget-icon"> <i class="fa fa-calculator"></i> </span>
                            <h2><strong>Unit Requests</strong> </h2>
                        </header>
                        <div>
                            <div className="jarviswidget-editbox"></div>
                            <div id="unit_request_inner" className="widget-body"><UnitRequestList /></div>
                        </div>
                    </div>
                </article>
            </div>
        )
    }
}